import React, { PointerEventHandler } from 'react';
import classNames from 'classnames';
import './Legend.scss';
import Tooltip, { TooltipText } from 'utils/components/Tooltip/Tooltip';

export interface LegendProps {
    className?: string;
    label: string;
    value?: string;
    suffix?: string;
    twoColourBorder?: boolean;
    hideDashWhenEmpty?: boolean;
    disabled?: boolean;
    onPointerMove?: PointerEventHandler<HTMLDivElement>;
    onMouseLeave?: () => void;
    onClick?: () => void;
    tooltip?: TooltipText;
}

export default function Legend({
    className,
    label,
    value,
    suffix,
    twoColourBorder,
    hideDashWhenEmpty,
    disabled,
    onPointerMove,
    onClick,
    tooltip,
    onMouseLeave,
}: LegendProps) {
    return (
        <Tooltip text={tooltip}>
            <div
                onPointerMove={onPointerMove}
                onMouseLeave={onMouseLeave}
                className={classNames(
                    'Legend',
                    className,
                    disabled && 'disabled',
                    twoColourBorder && 'two-colour-border',
                    onClick && 'clickable'
                )}
                onClick={onClick}
            >
                {twoColourBorder && renderTwoColourBorder()}
                <div className="label">{label}</div>
                <div className="value">
                    {value
                        ? `${value}${suffix ? suffix : ''}`
                        : hideDashWhenEmpty
                        ? ''
                        : '-'}
                </div>
            </div>
        </Tooltip>
    );
}

function renderTwoColourBorder() {
    return (
        <div className="two-colour-border-border">
            <div className="top" />
            <div className="bottom" />
        </div>
    );
}
